/**
 * Profile fields that a user can report as incorrect.
 *
 * Used by:
 * - FOConfirmationStep (onboarding — augmented with currentValue at runtime)
 * - SupportTicketForm "Data Problem" mode (support widget)
 */

export interface CorrectableField {
  id: string
  label: string
}

export const CORRECTABLE_FIELDS: CorrectableField[] = [
  { id: 'name', label: 'Name and Surname' },
  { id: 'personnelNumber', label: 'Personnel Number' },
  { id: 'roleTitle', label: 'Role Title' },
  { id: 'email', label: 'Email' },
  { id: 'function', label: 'Function' },
  { id: 'lineManager', label: 'People Leader' },
  { id: 'campus', label: 'Campus' },
  { id: 'faculty', label: 'Faculty' },
  { id: 'managerStatus', label: 'People Leader Status / Direct Reports' },
  { id: 'other', label: 'Other (specify in description)' },
]
